import { BannersApi } from 'api';
import useUserData from 'hooks/useUserData';
import React, { useContext, useState, useEffect, useMemo } from 'react';
import { BannerProps } from './BannerModel';

export interface BannersContextProps {
  isFetching: boolean;
  banners: BannerProps[];
}
const Context = React.createContext<BannersContextProps>({
  isFetching: true,
  banners: [],
});

const BannersContext = (props: React.PropsWithChildren<{ unauthorized?: boolean }>) => {
  const [isFetching, setIsFetching] = useState(true);
  const [banners, setBanners] = useState<BannerProps[]>([]);
  const userData = useUserData();
  const getBanners = async () => {
    if (!props.unauthorized && (!userData?.id || !userData?.userType)) {
      return setIsFetching(false);
    }

    const result = await BannersApi.getBanners(userData?.id || 0, userData?.userType || 'unauthorized');
    if (result)
      setBanners(
        result.map((el) => ({
          id: el.id,
          title: el.title || '',
          subtitle: el.text || '',
          button: el.buttonTitle || '',
          buttons: el.buttons || null,
          href: el.link || '',
          img: el.img || '',
          section: el.section || null,
        })),
      );
    setIsFetching(false);
  };
  useEffect(() => {
    getBanners();
  }, [userData?.id, userData?.userType]);

  return <Context.Provider value={{ isFetching, banners }}>{props.children}</Context.Provider>;
};

export const useBannersContext = (props?: { section?: string }) => {
  const context = useContext(Context);
  return { ...context, banners: context.banners.filter((el) => !props?.section || el.section === props?.section) };
};

export default BannersContext;
